/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'request': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M15 29c7.732 0 14-6.268 14-14S22.732 1 15 1 1 7.268 1 15s6.268 14 14 14zm0 1c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z" _fill="#fff"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M11.5 14v1h7v-1h-7zM11.5 12v1h7v-1h-7zM11.5 16v1h7v-1h-7zM11.5 18v1h7v-1h-7z" _fill="#fff"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M11.854 7.5H20.5v14h-11V10.876L11.854 7.5zm.522 1L10.5 11.19v9.31h9v-12h-7.124z" _fill="#fff"/>'
  }
})
